import { defineComponent as _defineComponent } from 'vue';
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
import { watch, ref } from 'vue';
import svgRegistry from '@ts/generated/svg-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SvgVue',
    props: {
        icon: {}
    },
    setup(__props) {
        const props = __props;
        const iconPath = getIconPath(props.icon);
        const svgString = getSvgString(iconPath);
        const svgAttributes = ref(getSvgAttributes(svgString));
        const svgContent = ref(getSvgContent(svgString));
        watch(() => props.icon, (newIcon) => {
            const newIconPath = getIconPath(newIcon);
            const newSvgString = getSvgString(newIconPath);
            svgAttributes.value = getSvgAttributes(newSvgString);
            svgContent.value = getSvgContent(newSvgString);
        });
        // viewBox="0 0 1792 1792"
        function getIconPath(icon) {
            return icon.replace(new RegExp('.'.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'), 'g'), '/') + '.svg';
        }
        function getSvgString(path) {
            const key = path.replace(/\.svg$/, '');
            return svgRegistry[key] ?? '';
        }
        function getSvgAttributes(str) {
            let attributes = {};
            if (!str)
                return attributes;
            let wrapper = document.createElement('div');
            wrapper.innerHTML = str;
            const attributeNodeMap = wrapper.firstElementChild ? wrapper.firstElementChild.attributes : undefined;
            if (!attributeNodeMap)
                return attributes;
            for (const attr of attributeNodeMap) {
                attributes[attr.name] = attr.value;
            }
            return attributes;
        }
        function getSvgContent(str) {
            return str ? str.replace(/^<svg[^>]*>|<\/svg>$/g, '') : '';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _mergeProps(svgAttributes.value, { innerHTML: svgContent.value }), null, 16 /* FULL_PROPS */, _hoisted_1));
        };
    }
});
